<template>
    <div class="col-lg-9 mx-auto">
        <header class="text-center mt-5 mt-md-0 mb-4">
            <h2 class="skin-page-heading">
                {{ title }}
            </h2>
        </header>

        <div class="container-fluid px-0 mt-0">
            
            <template v-if="isInactiveUser">
                <template v-if="selectedOption == null">
                    <p class="mx-5">
                        Our planning tools support you with actuarial calculations to build a retirement plan and help you monitor this
                        over time. This plan aims to show how your income goals could be met over your expected lifetime if things turn
                        out as expected.
                    </p>
                    <p class="mx-5">
                        We cannot provide advice on which products are suitable for you specifically, or how you should invest your money.
                        We can highlight a number of alternative high level options and show more details if you decide to click on these.
                    </p>
                    <p class="mx-5 mb-4 fw-bold">
                        If you want a specific recommendation on a suitable provider you must take the advice option below.
                    </p>
                </template>

                <management-choices v-if="selectedOption == null" @detail-requested="onDetailRequested"></management-choices>

                <d-i-y v-if="selectedOption == 'DIY'" @back="onBackClicked"></d-i-y>

                <product v-if="selectedOption == 'Guidance'" @back="onBackClicked"></product>

                <advice v-if="selectedOption == 'Advice'" @back="onBackClicked"></advice>
            </template>
            <template v-else>
                <p>Thank you for applying for the Pathlines pension product.</p>
                <p>Your application is now being processed. You can come back here to check on progress, or contact Pathlines directly.</p>
                <p>We will know when your Pathlines account is active. When that happens you will see further content here.</p>
            </template>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import { useStore } from "vuex";
import ManagementChoices from "./secure/ManagementChoices.vue";
import Product from "./secure/Product.vue";
import DIY from "./secure/DIY.vue";
import Advice from "./secure/Advice.vue";

type OptionType = 'DIY' | 'Guidance' | 'Advice';

const store = useStore();

const selectedOption = ref<null|OptionType>(null);

const isInactiveUser = computed<boolean>(() => {
    return !(store.state.retiree?.isApplicant ?? false);
});

const title = computed<string>(() => {
    return isInactiveUser.value ? "Options to put your plan in place" : "Putting your plan in place with guidance";
})

function onDetailRequested(option: OptionType) {
  selectedOption.value = option;
}

function onBackClicked() {
    selectedOption.value = null;
}
</script>
